/* eslint-disable
    import/no-duplicates,
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import EmbedConstants from 'constants/EmbedConstants'
import { captureException } from 'utils/SentryHelpers'
import { captureResponseException } from 'utils/SentryHelpers'

const EmbedQueries = Marty.createQueries({
  id: 'EmbedQueries',

  fetchEmbedList() {
    return new Promise((resolve, reject) => {
      const listPromise = this.app.sources.EmbedAPI.fetchEmbedList()

      listPromise.then(res => {
        if (res.status === 200) {
          this.dispatch(EmbedConstants.EMBED_FETCH_DONE, res.body)
          return resolve(true)
        } else {
          captureResponseException(res)
          this.dispatch(EmbedConstants.EMBED_FETCH_FAILED, res)
          return reject(res)
        }
      })

      return listPromise.catch(error => {
        captureException(error)
        this.dispatch(EmbedConstants.EMBED_FETCH_FAILED, inboxId, error)
        return reject(error)
      })
    })
  },

  createEmbedForInboxId(inboxId) {
    const promise = this.app.sources.EmbedAPI.createEmbedForInboxId(inboxId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(EmbedConstants.EMBED_CREATE_DONE, inboxId, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(EmbedConstants.EMBED_CREATE_FAILED, inboxId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(EmbedConstants.EMBED_CREATE_FAILED, inboxId, error)
    })
  }
})

export default EmbedQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/EmbedQueries.js